export default "__VITE_ASSET__BwmkhFxL__"